/* eslint-disable */
import { api } from './../../api.js';

const state = {
};

const getters = {

}

const mutations = {
}

const actions = {
    getSelectAccountManager: function({ commit }, data){
        return new Promise((resolve, reject) => {
            api.get('samples/account-manager/select', data).then((res) => {
                resolve(res);
            }).catch((error) => {
                reject(error.response);
            });
        });
    },
    SampleOrderSendClient: function({ commit }, data){
        return new Promise((resolve, reject) => {
            api.post('samples/' + data.id + '/send-client', data).then((res) => {
                resolve(res);
            }).catch((error) => {
                reject(error.response);
            });
        });
    },
    SampleOrderSendAmc: function({ commit }, data){
        return new Promise((resolve, reject) => {
            api.post('samples/' + data.id + '/send', data).then((res) => {
                resolve(res);
            }).catch((error) => {
                reject(error.response);
            });
        });
    },
    getTipoDocument: function({ commit }, data){
        return new Promise((resolve, reject) => {
            api.get('samples/' + data.sample_order_id + '/document/' + data.document_id + '/tipo', data).then((res) => {
                resolve(res);
            }).catch((error) => {
                reject(error.response);
            });
        });
    },
    copySampleOrder: function({ commit }, data){
        return new Promise((resolve, reject) => {
            api.post('samples/' + data.id + '/copy', data).then((res) => {
                resolve(res);
            }).catch((error) => {
                reject(error.response);
            });
        });
    },
    getLastSampleOrder: function({ commit }, data){
        return new Promise((resolve, reject) => {
            api.get('samples/last', data).then((res) => {
                resolve(res);
            }).catch((error) => {
                reject(error.response);
            });
        });
    },
    finishUpload: function({ commit }, data){
        return new Promise((resolve, reject) => {
            api.post('samples/' + data.sample_order_id + '/finish-upload', data).then((res) => {
                resolve(res);
            }).catch((error) => {
                reject(error.response);
            });
        });
    },
    deleteSampleFolder: function({ commit }, data){
        return new Promise((resolve, reject) => {
            api.delete('samples/' + data.order_id + '/folder/' + data.folder_id, data).then((res) => {
                resolve(res);
            }).catch((error) => {
                reject(error.response);
            });
        });
    },
    renameSampleFolder: function({ commit }, data){
        return new Promise((resolve, reject) => {
            api.patch('samples/' + data.order_id + '/folder/' + data.folder_id, data).then((res) => {
                resolve(res);
            }).catch((error) => {
                reject(error.response);
            });
        });
    },
    createSampleFolder: function({ commit }, data){
        return new Promise((resolve, reject) => {
            api.post('samples/' + data.order_id + '/folder/' + data.folder_id, data).then((res) => {
                resolve(res);
            }).catch((error) => {
                reject(error.response);
            });
        });
    },
    getDirectoriesSamples: function({ commit }, data){
        return new Promise((resolve, reject) => {
            api.get('samples/' + data.order_id + '/directories/sample', {}).then((res) => {
                resolve(res);
            }).catch((error) => {
                reject(error.response);
            });
        });
    },
    getDirectoriesFtn: function({ commit }, data){
        return new Promise((resolve, reject) => {
            api.get('samples/' + data.order_id + '/directories/ftn', {}).then((res) => {
                resolve(res);
            }).catch((error) => {
                reject(error.response);
            });
        });
    },
    updateSampleOrderLine:  function({ commit }, data){
        return new Promise((resolve, reject) => {
            api.patch('samples/' + data.sample_order_id + '/products/' + data.product_id, data.data).then((res) => {
                resolve(res);
            }).catch((error) => {
                reject(error.response);
            });
        });
    },
    updateStatusSampleOrders: function({ commit }, data){
        return new Promise((resolve, reject) => {
            api.patch('samples/' + data.id + '/status', data).then((res) => {
                resolve(res);
            }).catch((error) => {
                reject(error.response);
            });
        });
    },
    createSampleOrderLineFeedback : function({ commit }, data){
        return new Promise((resolve, reject) => {
            api.post('samples/' + data.sample_order_id + '/products/' + data.sample_order_line_id + '/feedback', data).then((res) => {
                resolve(res);
            }).catch((error) => {
                reject(error.response);
            });
        });
    },
    getSampleOrderLineFeedback : function({ commit }, data){
        return new Promise((resolve, reject) => {
            api.get('samples/' + data.sample_order_id + '/products/' + data.sample_order_line_id + '/feedback', data).then((res) => {
                resolve(res);
            }).catch((error) => {
                reject(error.response);
            });
        });
    },
    editTrackNumber : function({ commit }, data){
        return new Promise((resolve, reject) => {
            api.post('samples/' + data.sample_order_id + '/track-number', data).then((res) => {
                resolve(res);
            }).catch((error) => {
                reject(error.response);
            });
        });
    },
    sentSampleOrderLine : function({ commit }, data){
        return new Promise((resolve, reject) => {
            api.post('samples/' + data.sample_order_id + '/products/' + data.sample_order_line_id + '/sent', data).then((res) => {
                resolve(res);
            }).catch((error) => {
                reject(error.response);
            });
        });
    },
    deleteSampleOrder : function({ commit }, data){
        return new Promise((resolve, reject) => {
            api.delete('samples/' + data.id, {}).then((res) => {
                resolve(res);
            }).catch((error) => {
                reject(error.response);
            });
        });
    },
    createSample : function({ commit }, data){
        return new Promise((resolve, reject) => {
            api.post('samples', data).then((res) => {
                resolve(res);
            }).catch((error) => {
                reject(error.response);
            });
        });
    },
    updateSample : function({ commit }, data){
        return new Promise((resolve, reject) => {
            api.patch('samples/' + data.id, data.data).then((res) => {
                resolve(res);
            }).catch((error) => {
                reject(error.response);
            });
        });
    },
    getSamples : function({ commit }, data){
        return new Promise((resolve, reject) => {
            api.get('samples', data).then((res) => {
                resolve(res);
            }).catch((error) => {
                reject(error.response);
            });
        });
    },
    getSampleOrderDetail : function({ commit }, data){
        return new Promise((resolve, reject) => {
            api.get('samples/' + data.id, {}).then((res) => {
                resolve(res);
            }).catch((error) => {
                reject(error.response);
            });
        });
    },
    getSampleOrderComments : function({ commit }, data){
        return new Promise((resolve, reject) => {
            api.get('samples/' + data.id + '/comments', {}).then((res) => {
                resolve(res);
            }).catch((error) => {
                reject(error.response);
            });
        });
    },
    postSampleOrderComment : function({ commit }, data){
        return new Promise((resolve, reject) => {
            api.post('samples/' + data.id + '/comments', data).then((res) => {
                resolve(res);
            }).catch((error) => {
                reject(error.response);
            });
        });
    },
    getSampleOrderLines : function({ commit }, data){
        return new Promise((resolve, reject) => {
            api.get('samples/' + data.id + '/products', data).then((res) => {
                resolve(res);
            }).catch((error) => {
                reject(error.response);
            });
        });
    },

    getSampleOrderLines2 : function({ commit }, data){
        return new Promise((resolve, reject) => {
            api.get('samples/orders', data).then((res) => {
                resolve(res);
            }).catch((error) => {
                reject(error.response);
            });
        });
    },

    getSampleOrdersToSelect : function({ commit }, data){
      return new Promise((resolve, reject) => {
        api.get('samples/orders/to-select', data).then((res) => {
            resolve(res);
        }).catch((error) => {
            reject(error.response);
        });
    });
    },


    deleteSampleOrderLines : function({ commit }, data){
        return new Promise((resolve, reject) => {
            api.delete('samples/' + data.sample_id + '/products/' + data.sample_order_line_id, data).then((res) => {
                resolve(res);
            }).catch((error) => {
                reject(error.response);
            });
        });
    },
    createSampleOrderLine : function({ commit }, data){
        return new Promise((resolve, reject) => {
            api.post('samples/' + data.id + '/products', data).then((res) => {
                resolve(res);
            }).catch((error) => {
                reject(error.response);
            });
        });
    },


    samplesToSelect : function({ commit }, data){
      return new Promise((resolve, reject) => {
        api.get('samples/to-select?search=' + data.search, data).then((res) => {
            resolve(res);
        }).catch((error) => {
            reject(error.response);
        });
    });

    }
}

export default {
    state,
    actions,
    getters,
    mutations
};



// WEBPACK FOOTER //
// ./src/store/modules/SamplesModule.js